import axios from 'axios';
const base = 'task';

function getOTServicio(query = null) {
  // return Promise.resolve({ ots: [] });
  {/* ZTASK-PRODUCCION */}
  return axios.get(`${base}/ot/servicio`, { params: query });
}

function getTareasCuadrillaByOT(nroOT) {
  return axios.get(`${base}/ot/cuadrilla/tareas`, { params: { nroOT } });
}

const ZTaskService = {
  getOTServicio,
  getTareasCuadrillaByOT
};
export default ZTaskService;
